import React from "react";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { routes } from "utilities/routing/generatedRoutes";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { AppointmentPhase } from "components";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";

const GroundTransportFromTo = ({ groundTransport }: { groundTransport: server.dto.GroundTransportForList }) => {

  const startDateWritten = formatWrittenDayMonthYear(groundTransport.appointmentDateTime.startDisplay);
  const endDateWritten = formatWrittenDayMonthYear(groundTransport.appointmentDateTime.endDisplay);

  const startTimeWritten = formatTime(groundTransport.appointmentDateTime.startDisplay);
  const endTimeWritten = formatTime(groundTransport.appointmentDateTime.endDisplay);

  const arrivalDateAndTime = startDateWritten === endDateWritten
    ? endTimeWritten
    : `${endDateWritten} ${endTimeWritten}`;

  return <div className="flex-2 journey-card-grid">
    <div className="departs-from">
      <div className="info-text-regular margin-bottom-large">
        {startDateWritten}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {groundTransport.startGooglePlaceName}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {groundTransport.startGooglePlaceAddress}
      </div>
    </div>
    <div className="departure-time nowrap info-text-regular">
      {startTimeWritten}
    </div>
    <div className="arrow">
      <i className="icon-arrow-right small" />
    </div>
    <div className="arrives-at">
      <div className="info-text-regular margin-bottom-large">
        {arrivalDateAndTime}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {groundTransport.endGooglePlaceName}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {groundTransport.endGooglePlaceAddress}
      </div>
    </div>
  </div>;
};

export const cardLayout = (onShowChange: () => void): ListTemplateLayout<server.dto.GroundTransportForList> => ({
  type: "card",
  sections: {
    renderTitle: item =>
      <LargeClickableTitle
        uri={routes.groundTransport_Detail(item.groundTransportId).absolute}
        icon={<AppointmentPhase value={item.phase} displayLabel={false} />}
        title={item.title}
      />,
    hideTitle: () => false,
    renderBody: item => <>
      <GroundTransportFromTo groundTransport={item} />
      <LinkedShowsList onChange={onShowChange} shows={item.linkedShows} />
    </>,
    renderFooter: item => <div>
      <div className="margin-bottom-small">
        <span>{item.artist.name}</span>
      </div>
      <div>
        {item.travellers.map((traveller, index) => <React.Fragment key={traveller.contactId}>
          <span className="s1_gray">{traveller.name.fullName}</span>
          {item.travellers.length - 1 !== index && <span className="s1_gray">, </span>}
        </React.Fragment>)}
      </div>
    </div>,
    hideFooter: item => !item.artist && item.travellers.length === 0
  }
});